module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-181.88a158a.woff2";